// extracted by mini-css-extract-plugin
module.exports = {"container":"PageIntro_container__2nSaG","intro":"PageIntro_intro__3dHnH"};